import {action, extendObservable} from 'mobx';
import {FETCH_URL} from "../constants/ServerLinks";

class City {

    constructor({city = []}, cityId) {

        extendObservable(this, city);
        this.apiUrl = FETCH_URL + '/api/v1/cities/parameters/?city_id=' + cityId.toString();
    }

    @action
    fetchCity = async () => {
        const response = await fetch(`${this.apiUrl}`);
        const db_city = await response.json();
        console.log("Fetching City Data: " + JSON.stringify(db_city))
        this.city = db_city.data;
    };

}

export default City;
